import React from "react";

const WhatElseBox = ({ data }) => {
  return (
    <div className="WhatElseBox">
      <div className="WhatElseBox__Left">
        {data?.icon ? (
          <img src={data?.icon} alt="" width="20" height="20" />
        ) : null}
      </div>
      <div className="WhatElseBox__Right">
        <div className="WhatElseBox__Right__Heading">{data?.heading}</div>
        <div className="WhatElseBox__Right__Description">
          {data?.subHeading}
        </div>
      </div>
    </div>
  );
};

{/*<Image src={`/api/proxyimage?url=${encodeURIComponent(data?.icon)}`} alt="l" width={20} height={20} />*/ }

export default WhatElseBox;
